export default class ProviderFactory {
    // #region Vars
    _provider;
    // #endregion
    // #region Properties
    provider() {
        return this._provider;
    }
    // #endregion
    // #region Constructor
    constructor() {
        this._provider = new Map();
    }
    // #endregion    
    // #region Core
    register(scope, name, provider) {
        //Scope
        if (!this._provider.has(scope)) {
            this._provider.set(scope, new Map());
        }
        //Provider
        this._provider.get(scope)?.set(name, provider);
    }
    get(scope, name) {
        if (!this._provider.has(scope)) {
            return undefined;
        }
        if (!this._provider.get(scope)?.has(name)) {
            return undefined;
        }
        let tProvider = this._provider.get(scope)?.get(name);
        if (tProvider instanceof Function) {
            return tProvider();
        }
        else {
            return tProvider;
        }
    }
}
